import invoice from "../../assets/pdfs/invoice.pdf";

const options = [
  { label: "Monthly", value: "monthly" },
  { label: "Yearly", value: "yearly" },
  { label: "Weekly", value: "weekly" },
];

const data = {
  fundedDeals: [
    {
      companyName: "Karur Fabrics",
      invoiceNumber: "INV-202510122",
      fromTo: "Dammam, SA <> Karur, IND",
      deployedCredit: "$2,500,000",
      dealType: "Pre-Production",
      status: "Production",
      dueDate: "11/10/2025",
      repayment: "Pending",
    },
    {
      companyName: "Red Chamber",
      invoiceNumber: "INV-202510122",
      fromTo: "Berlin, DE <> Los Angeles, USA",
      deployedCredit: "$2,000,000",
      dealType: "Post-Production",
      status: "Waiting Pickup",
      dueDate: "11/18/2025",
      repayment: "Pending",
    },
    {
      companyName: "Daiwa Exports",
      invoiceNumber: "INV-202510122",
      fromTo: "Chicago, USA <> Port Klang, Malaysia",
      deployedCredit: "$1,800,000",
      dealType: "Container Loading",
      status: "Ocean Transit",
      dueDate: "11/18/2025",
      repayment: "Paid",
      url: "https://www.gocomet.com/customer/integration/tracking/1f1a5da9-5f56-47da-af34-99b3e71e93a1",
    },
    {
      companyName: "Nike Gmbh",
      invoiceNumber: "INV-202510122",
      fromTo: "Berlin, DE <> New York, USA",
      deployedCredit: "$1,000,000",
      dealType: "Port Departure",
      status: "Road Transit",
      dueDate: "12/11/2025",
      repayment: "Pending",
    },
    {
      companyName: "Dookan",
      invoiceNumber: "INV-202510122",
      fromTo: "Tuticorin, IND <> Prague, CZ",
      deployedCredit: "$2,000,000",
      dealType: "After Shipment",
      status: "Destination Port",
      dueDate: "12/12/2025",
      repayment: "Pending",
    },
    {
      companyName: "CRV Corp",
      invoiceNumber: "INV-202510122",
      fromTo: "Chicago, USA <> Port Klang, Malaysia",
      deployedCredit: "$3,000,000",
      dealType: "After Shipment",
      status: "Ocean Transit",
      dueDate: "12/23/2025",
      repayment: "Pending",
      url: "https://www.gocomet.com/customer/integration/tracking/77a082e1-e7e9-4415-b637-98eaeacfc8ce",
    },
  ],
  pagination: {
    currentPage: 1,
    totalPages: 2,
  },
};

type FundedDeal = (typeof data.fundedDeals)[number];

const headers = data.fundedDeals.length
  ? (Object.keys(data.fundedDeals[0]) as (keyof FundedDeal)[])
  : [];

const formatHeader = (key: string) =>
  key === "fromTo"
    ? "From <> To"
    : key.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase());

const repaymentBadge = (status: string) => {
  switch (status.toLowerCase()) {
    case "paid":
      return "bg-green-100 text-green-700";
    case "pending":
      return "bg-yellow-100 text-yellow-700";
    case "overdue":
      return "bg-red-100 text-red-700";
    default:
      return "bg-gray-100 text-gray-700";
  }
};

export default function FundedDeals() {
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.toLowerCase();

    document
      .querySelectorAll<HTMLTableRowElement>("tbody tr[data-row]")
      .forEach((row) => {
        const haystack = row.dataset.search || "";
        const match = haystack.includes(val);

        if (match) {
          // show row
          row.style.display = "";
          requestAnimationFrame(() => {
            row.style.opacity = "1";
          });
        } else {
          // fade out, then remove from layout
          row.style.opacity = "0";

          const handler = () => {
            row.style.display = "none";
            row.removeEventListener("transitionend", handler);
          };

          row.addEventListener("transitionend", handler);
        }
      });
  };

  return (
    <div className="card">
      {/* Header */}
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-lg font-semibold text-gray-800">Funded Deals</h2>

        <div className="flex items-center gap-3">
          <input
            type="text"
            placeholder="Search"
            className="input-new !w-64"
            onChange={handleOnChange}
          />

          <select className="input-new w-40">
            {options.map((el) => (
              <option value={el.value} key={el.label}>
                {el.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="mt-6 overflow-x-auto">
        <table className="min-w-full table-auto text-left">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-200">
              {headers.map((key) => (
                <th key={key} className="p-4 text-xs font-medium text-gray-600">
                  {formatHeader(String(key))}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.fundedDeals.map((deal, idx) => {
              const searchBlob = Object.values(deal).join(" ").toLowerCase();

              return (
                <tr
                  key={idx}
                  data-row
                  data-search={searchBlob}
                  className="border-b border-gray-200 hover:bg-slate-200 transition-all duration-200 ease-in-out"
                >
                  {headers.map((key) => {
                    const value = deal[key];

                    return (
                      <td key={key} className="p-4 text-xs text-gray-900">
                        {key === "repayment" ? (
                          <span
                            className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${repaymentBadge(
                              String(value)
                            )}`}
                          >
                            {value}
                          </span>
                        ) : value === "Ocean Transit" ? (
                          <ContainerStatusInfo url={deal.url!} />
                        ) : value === "INV-202510122" ? (
                          <InvoiceInfo
                            url={invoice}
                            invoiceNumber={deal.invoiceNumber}
                          />
                        ) : (
                          value
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

import { useState } from "react";
import { CrossIcon } from "../../components/Icons";
import CustomModal from "../../components/DealTracker/CustomModal";

function ContainerStatusInfo({ url }: { url: string }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  return (
    <div>
      <button
        onClick={toggleModal}
        className="text-custom-blue-medium text-xs font-semibold underline"
      >
        Ocean Transit
      </button>

      <CustomModal
        open={isModalOpen}
        onClose={toggleModal}
        className="bg-white rounded-xl shadow-xl p-6 max-w-6xl h-full w-full"
      >
        <button onClick={toggleModal} className="float-end hover:scale-95">
          <CrossIcon className="size-6" />
        </button>

        <h2 className="text-gray-900 font-medium mb-4 space-x-1">
          Tracking status
        </h2>

        <iframe
          src={url}
          width="100%"
          height="95%"
          style={{ border: 0 }}
        ></iframe>
      </CustomModal>
    </div>
  );
}

function InvoiceInfo({
  url,
  invoiceNumber,
}: {
  url: string;
  invoiceNumber: string;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  return (
    <div>
      <button
        onClick={toggleModal}
        className="text-custom-blue-medium text-xs font-medium hover:underline"
      >
        {invoiceNumber}
      </button>

      <CustomModal
        open={isModalOpen}
        onClose={toggleModal}
        className="p-6 max-w-6xl h-full w-full"
      >
        <button
          onClick={toggleModal}
          className="float-end mb-2 text-white hover:scale-90 hover:text-red-400"
        >
          <CrossIcon className="size-8" strokeWidth="2" />
        </button>

        <h2 className="text-white text-2xl font-medium">Invoice</h2>

        <iframe
          src={url}
          width="100%"
          height="95%"
          style={{ border: 0 }}
        ></iframe>
      </CustomModal>
    </div>
  );
}
